export default "__VITE_ASSET__jSp9Ur3T__"